import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=7faf8944&"
import script from "./CandidateProfile.vue?vue&type=script&lang=js&"
export * from "./CandidateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports